import React, { useCallback, useState } from 'react';
import { setUpgradeModalHandler } from '@/src/utils/api-client';
import { UpgradeModal } from './upgrade-modal';
import { useRouter } from 'next/navigation';

export function UpgradeModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const router = useRouter();

  const handleShowModal = useCallback((msg: string) => {
    setMessage(msg);
    setOpen(true);
  }, []);

  React.useEffect(() => {
    setUpgradeModalHandler(handleShowModal);
  }, [handleShowModal]);

  const handleUpgrade = () => {
    setOpen(false);
    router.push('/upgrade');
  };

  const handleStay = () => {
    setOpen(false);
  };

  return (
    <>
      <UpgradeModal
        open={open}
        message={message}
        onUpgrade={handleUpgrade}
        onStay={handleStay}
      />
      {children}
    </>
  );
}
